import { UserActivationView } from "@/features/admin/user-activation/UserActivationView";
import { useSelectOnboardingJourneyUsers } from "@/features/admin/user-activation/api/selectOnboardingJourneyUsers";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/customers/success")({
    component: CustomerSuccessPage,
});

function CustomerSuccessPage() {
    useNav([
        { label: "Customers", route: { to: "/customers/success" } },
        { label: "Success", route: { to: "/customers/success" } },
    ]);

    const { data: users = [], isLoading } = useSelectOnboardingJourneyUsers();

    return (
        <UserActivationView
            users={users}
            isLoading={isLoading}
            eyebrow="Customers"
            title="Success"
            description="Live activation progress for clinicians, patients, and secretaries. Open a row for progress and message timeline."
            timelineMode="live"
        />
    );
}
